export enum Country {
  FRANCE = 'FR',
  ENGLAND = 'GB',
  SPAIN = 'ES',
  BELGIUM = 'BE',
  BRAZIL = 'BR',
  PORTUGAL = 'PT',
  AUSTRALIA = 'AU',
  UNITED_STATES = 'US',
  SWITZERLAND = 'CH',
  INDIA = 'IN',
  ITALY = 'IT',
  GERMANY = 'DE',
  AUSTRIA = 'AT',
}
